"use client";

import { Card } from "@/components/ui/card";
import { Image as ImageIcon } from "lucide-react";

export const UmrahCardLoadingSkeleton = () => {
  return (
    <Card className="mb-4 w-full animate-pulse overflow-hidden rounded-lg p-0 shadow">
      <div className="grid grid-cols-1 gap-0 md:grid-cols-3">
        <div className="flex h-55 w-full items-center justify-center bg-muted">
          <div className="rounded-full border border-background p-5">
            <ImageIcon className="text-muted-foreground" />
          </div>
        </div>
        <div className="flex w-full flex-col justify-between px-4 py-3">
          <div>
            <div className="h-6 w-1/2 rounded bg-muted" />
            <div className="mt-2 h-4 w-2/3 rounded bg-muted" />
            <div className="mt-4 h-4 w-3/4 rounded bg-muted" />
            <div className="mt-4 h-4 w-2/3 rounded bg-muted" />
          </div>
        </div>
        <div className="w-full bg-primary/10 px-4 py-3">
          <div className="h-4 w-1/2 rounded bg-muted" />
          <div className="mt-2 h-4 w-1/2 rounded bg-muted" />
          <div className="mt-2 h-10 w-full rounded bg-muted" />
        </div>
      </div>
    </Card>
  );
};
